var lib = { };

lib.URL = function (service) {

    let INTERNAL_STAG_URL = "https://api-internal.safe2pay-h.com.br/v2";
    let INTERNAL_PROD_URL = "https://api-internal.safe2pay.com.br/v2";
    let INTERNAL_LOCAL_URL = "http://localhost:11076/v2";

    if (isStaging()) {
        return INTERNAL_STAG_URL + service;
    } else if (isLocal()) {
        return INTERNAL_LOCAL_URL + service;
    } else
        return INTERNAL_PROD_URL + service;

}
lib.AuthURL = function (service) {

    let AUTH_STAG_URL = "https://authentication.safe2pay-h.com.br/v2";
    let AUTH_PROD_URL = "https://auth.safe2pay.com.br/v2";
    let AUTH_LOCAL_URL =  "http://localhost:61745/v2";

    if (isStaging()) {
        return AUTH_STAG_URL + service;
    } else if (isLocal()) {
        return AUTH_LOCAL_URL + service;
    } else
        return AUTH_PROD_URL + service;
}

function isStaging() {
    return window.location.host.indexOf('-h') >= 0;
}

function isLocal() {
    return window.location.host.indexOf('local') >= 0;
}

module.exports = lib



// WEBPACK FOOTER //
// ./src/libs/ApiHandler.js